import type { Sort, SortDirection } from '@library/types/utils';
import arrowDownIcon from '@library/assets/images/icons/arrow-down.svg';
import whiteArrowDownIcon from '@library/assets/images/icons/white-arrow-down.svg';

export interface SortIndicatorProps {
  className?: string;
  column: string;
  sort: Sort;
}

export const SortIndicator = ({
  className = undefined,
  column,
  sort
}: SortIndicatorProps) => {
  const { sortBy, sortDirection } = sort;

  const getArrowIcon = (buttonSortDirection: SortDirection) => {
    if (sortBy === column && buttonSortDirection === sortDirection) {
      return whiteArrowDownIcon;
    }

    return arrowDownIcon;
  };

  return (
    <div className={className}>
      <img
        className="rotate-180"
        src={getArrowIcon('asc')}
        alt="arrow up icon"
      />
      <img src={getArrowIcon('desc')} alt="arrow down icon" />
    </div>
  );
};
